import { render, staticRenderFns } from "./daliy-sign.vue?vue&type=template&id=2f7d54ea&scoped=true&"
import script from "./daliy-sign.vue?vue&type=script&lang=js&"
export * from "./daliy-sign.vue?vue&type=script&lang=js&"
import style0 from "./daliy-sign.vue?vue&type=style&index=0&id=2f7d54ea&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f7d54ea",
  null
  
)

export default component.exports